import React from "react";

const WHATSAPP_NUMBER = "5588988676142"; // +55 88 9.8867-6142
const WHATSAPP_MSG = encodeURIComponent("Olá! Vim pelo site do UniPlay HD e gostaria de mais informações.");

export default function SupportChat() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-24 right-4 md:bottom-28 md:right-6 z-40 group flex items-center gap-2"
    >
      <span className="hidden md:inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#25D366] text-white text-xs font-semibold shadow-lg opacity-0 group-hover:opacity-100 transition translate-x-2 group-hover:translate-x-0">
        Fale conosco
      </span>
      <span className="relative w-14 h-14 rounded-full bg-[#25D366] shadow-2xl shadow-[#25D366]/50 flex items-center justify-center hover:brightness-110 transition">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <svg viewBox="0 0 32 32" className="relative w-7 h-7 fill-white" aria-hidden="true">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.345 0 2.19-.43 2.19-1.604 0-.058 0-.144-.03-.215-.13-.402-1.91-1.193-2.146-1.193zm-2.939 7.107c-1.776 0-3.523-.516-4.998-1.477L7.71 23.99l1.21-3.59a8.93 8.93 0 0 1-1.72-5.28c0-4.928 4.027-8.954 8.954-8.954a8.86 8.86 0 0 1 6.323 2.62 8.86 8.86 0 0 1 2.62 6.323c.029 4.928-3.998 8.954-8.926 8.954zm0-19.66C10.998 4.652 6.36 9.292 6.36 14.984c0 1.81.473 3.595 1.376 5.158L6 26l5.96-1.706a10.396 10.396 0 0 0 4.94 1.246h.003c5.69 0 10.43-4.64 10.43-10.33 0-2.78-1.142-5.388-3.092-7.336a10.39 10.39 0 0 0-7.337-3.092z" />
        </svg>
      </span>
    </a>
  );
}
